import Vue from 'vue'
import reinvoicingTransformer from '@/transformers/taxReceipt/reinvoicing'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Sends reinvoicing file
 *
 * @param  payload
 * @return {Array} File's info
 */

const requestReinvoicing = payload =>
  Vue.$http.post('taxreceipt/reinvoice-request/', reinvoicingTransformer.send(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default requestReinvoicing


// WEBPACK FOOTER //
// ./src/services/taxReceipt/requestReinvoicing.js